/**
 * Finding 卡片样式 token — Figma `90772:39508` / Plan Gate `45331:418673`。
 *
 * 从 plan gate 抽离为共享常量，避免 DiagnosisFindingsPanel 与 PlanGate 双向依赖。
 */

import { ospThemes } from "@ospweb/sdk-ui";

export const DIAGNOSIS_FINDING_TAG = {
  bg: ospThemes.colors.content_aura_lv3_primary,
  iconSrc: "/assets/plan-gate/finding-error.svg",
} as const;

export const DIAGNOSIS_FINDING_CARD = {
  radiusClass: "rounded-lg",
  bodyBg: ospThemes.colors.background_clearcover,
  blurPx: 10,
  titleClass: "title_l text-content_inverse_primary",
  descClass: "body_s text-content_inverse_primary",
  tagLabelClass: "body_medium_s text-content_primary",
} as const;
